import { useJpdPlanTitlesAllowList } from "../../../pricing-calculator/src/configs/jpd.pricing-calculator-config";
import { PlanTitle } from "../types.ts";

export const useEffectivePlanTitles = (
    planTitles: PlanTitle[],
    urlSlug?: string
) => {
    // Single source of truth for the JPD plan-title allow-list (gated
    // behind the GWP-10907 feature flag). Always invoked to satisfy the
    // Rules of Hooks; the result is only USED for `product-discovery`.
    const jpdPlanTitlesAllowList = useJpdPlanTitlesAllowList();

    const allTitles = planTitles.map(({ fields }) => fields.planTitleExternal);
    if (urlSlug === "product-discovery") {
        const allowSet = new Set(jpdPlanTitlesAllowList);
        return allTitles.filter((title) => allowSet.has(title));
    }
    return allTitles;
};
